import { SHARED_FILTERS } from './send-mail-stepper-shared-filters';

export const MAILING_GROUP_CRM_EDIT = {
  path: '/mailing/groups/edit/:id',
  filters: SHARED_FILTERS
};